import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';

/**
 * alpha-team
 * CLOUDWEB-17682: Качество. Touch. Паблик. Скрытие/показ навигации на одиночном паблике по тапу
 */
export const abPublicMobileSnackbarToggle: boolean = EnvironmentSelectors.isMobile() && getFeature('ab-public-mobile-snackbar-toggle');
